import React from 'react';
import Button from 'olive-react-myoneui/lib/Button';
import { trophyIcon, MessageQuestionIcon, clockIcon, rightArrowLong, checkCircleComplete } from '../../../constants/icons';
import { courseMaterialUrl } from '../../../../helpers/url_helper';

function handleClick(courseId, lectureId, slug) {
  window.location.href = courseMaterialUrl(courseId,lectureId,`student-dashboard/courses/detail/${slug}`, false)
}
const TestCard = ({
  testStatus,
  date,
  title,
  questions,
  marksScored,
  totalMarks,
  duration,
  totalDuration,
  grade,
  icon,
  courseId,
  lectureId,
  slug,
  attemptData
}) => {
  return (
    <>
      <div className={`icon-wrap ${testStatus === 'completed' ? 'completed' : 'notstarted'}`}>{icon}</div>
      <div className="myk__stu-course_test-report">
        <span className="myk__stu-test-time">{date}</span>
        <h3>{title}</h3>
        <ul className="course_test-analytics">
          <li>
            <div className="course_test-metadata">
              <h4>{MessageQuestionIcon} Questions</h4>
              <p><strong>{questions}</strong></p>
            </div>
          </li>
          <li>
            <div className="course_test-metadata">
              <h4>{checkCircleComplete} Marks scored</h4>
              <p><strong>{marksScored}</strong> / {totalMarks}</p>
            </div>
          </li>
          <li>
            <div className="course_test-metadata">
              <h4>{clockIcon} Duration</h4>
              <p><strong>{duration}</strong> / {totalDuration}</p>
            </div>
          </li>
          <li>
            <div className="course_test-metadata">
              <h4>{trophyIcon} Grade</h4>
              <p><strong>{grade}</strong></p>
            </div>
          </li>
        </ul>
        <div className="course_test-actions">
          {testStatus === "completed" ?
            <>
            {attemptData !== '' && Object.keys(attemptData).length > 0 && marksScored < totalMarks &&
            <Button variant="outline" className="btn-sm text-primary border-primary" onClick={() => handleClick(courseId, lectureId, slug)}>Retry</Button>
            }
            </>
            :
            <Button variant="primary" className="btn-sm" onClick={() => handleClick(courseId, 0, slug)}>Start Test {rightArrowLong}</Button>
           }
        </div>
      </div>
    </>
  );
};

export default TestCard;
